import { render } from "./InternationalTradeExportTable.vue?vue&type=template&id=11da4607&scoped=true"
import script from "./InternationalTradeExportTable.vue?vue&type=script&lang=js"
export * from "./InternationalTradeExportTable.vue?vue&type=script&lang=js"

import "./InternationalTradeExportTable.vue?vue&type=style&index=0&id=11da4607&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11da4607"]])

export default __exports__